var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 1.25h5.976c.73 0 1.43.29 1.946.806l4.273 4.278a2.75 2.75 0 01.805 1.944v11.904c0 .71-.21 1.368-.677 1.853-.47.488-1.118.715-1.823.715H6.75c-.705 0-1.353-.227-1.823-.715-.466-.485-.677-1.143-.677-1.853V3.819c0-.71.21-1.369.677-1.853.47-.488 1.118-.716 1.823-.716zm6.746 6.25V3.015L17.979 7.5h-4.483zM6.75 2.75c-.382 0-.609.117-.742.256-.137.142-.258.393-.258.813v16.363c0 .42.12.67.258.812.133.14.36.256.742.256h10.5c.382 0 .609-.117.742-.256.137-.142.258-.393.258-.812L18.246 9h-5.5a.75.75 0 01-.75-.75v-5.5H6.75z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.996 17.25a.75.75 0 01.75-.75h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 01-.75-.75zm0-4a.75.75 0 01.75-.75h6.5a.75.75 0 010 1.5h-6.5a.75.75 0 01-.75-.75z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/Page.3589d53674b9776f0f3e78e1101db6ed.svg";
export { ForwardRef as ReactComponent };